var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('list',{ref:"list"},[_c('template',{slot:"column"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }